const styles = theme => ({
  headerTableCell: {
    backgroundColor: '#F4F6F8',
    fontSize: '15px',
    color: '#002E47',
    fontFamily: 'Inter',
    fontWeight: 700,
    textAlign: 'center',
    width: '15%',
    borderBottom: 'none',
    padding: '12px 8px',
  },
  headerTableCell2: {
    backgroundColor: '#F4F6F8',
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '150%',
    width: '40%',
    borderBottom: 'none',
    padding: '12px 16px',
    borderRadius: '8px 0 0 8px',
  },
})

export default styles
